import type { IconData } from '@stacksjs/iconify-core'

export const mc4x3: IconData = {
  "body": "<g fill-rule=\"evenodd\" stroke-width=\"1pt\"><path fill=\"#f31830\" d=\"M0 0h640v240H0z\"/><path fill=\"#fff\" d=\"M0 240h640v240H0z\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default mc4x3
